import PropTypes from 'prop-types'
import { BlockLayout, CardTitle } from '@usb-ui-tools/react-billpay-layout'
import USBIconArrowLeft from '@usb-shield/react-icons/dist/esm/icon-arrow-left'
import USBLink from '@usb-shield/react-link/dist/esm'
import { useMultilingualService } from '../../../../../service/multilingualService'
import { isOLBOrIpadApp } from '../../../../../utils/browserutils'
import { selectedBillerDetails } from '../../../../../graphql/cache/localCache'

/**
 * @typedef {Object} search error
 */
/**
 * Returns Dashboard Header
 * @function
 * @param {func} onAddbillManually - locale of search error
 * @returns {HTMLElement} Returns error message with redirection link
 */

const DashBoardHeader = ({ redirectToDashboard }) => {
  const { HEADER } = useMultilingualService('addBillDashboard')
  const { selectedBill = {} } = selectedBillerDetails() || {}
  const { payeeExist = false } = selectedBill

  return (
    <>
      <CardTitle
        {...{
          pageTitleText: payeeExist
            ? HEADER?.DASHBOARD_HEADER_RETURN
            : HEADER?.DASHBOARD_HEADER,
          cardTitleText: !isOLBOrIpadApp()
            ? 'Pay all of your bills in one place.'
            : '',
          cardOtherBlockProps: { mobileTopMargin: '0' },
          showAvatar: false,
          id: 'payee-dashboard-header',
          isOLBOrIpadApp,
          cardTitleTextSameAsPageTitleText: false,
          compact: true,
          pageContentOnTop: isOLBOrIpadApp() && payeeExist && (
            <section className="usb-tg-subheader-large usb-c-interaction-blue">
              <USBLink
                handleClick={() => {
                  redirectToDashboard()
                }}
              >
                <USBIconArrowLeft
                  colorVariant="interaction"
                  style={{ position: 'relative', top: '3px' }}
                />
                <span
                  className="usb-tg-subheader-large"
                  style={{ marginLeft: '0.75rem' }}
                >
                  Back to bills
                </span>
              </USBLink>
            </section>
          ),
          mobileZeroBottomMarginFirstChild: !isOLBOrIpadApp() && true,
          gapThruMarginTop: true
        }}
      />
      <BlockLayout
        contentOnTop={
          <p
            id="payee-dashboard-header-additional-info"
            className="usb-tg-body-medium usb-c-gray-80"
          >
            {HEADER?.DASHBOARD_SUB_TITLE}
          </p>
        }
        mobileTopMargin="0"
        mobileBottomMargin="0"
        gapOnBottom="8"
        compact
      />
    </>
  )
}

DashBoardHeader.propTypes = {
  redirectToDashboard: PropTypes.func.isRequired
}

export default DashBoardHeader
